var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('section',{staticClass:"account-quick-panel"},[_c('div',{staticClass:"page-container"},[_c('miles-earned-component'),_vm._v(" "),_c('offers-claimed-chart-component')],1)])}
var staticRenderFns = []

export { render, staticRenderFns }